import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Clock } from 'lucide-react';
import BaseNav from '../common/BaseNav';

interface NotesNavProps {
  onNewNote: () => void;
  onToggleRecentNotes: () => void;
  showRecentNotes: boolean;
}

const NotesNav = ({ onNewNote, onToggleRecentNotes, showRecentNotes }: NotesNavProps) => (
  <BaseNav
    leftActions={
      <>
        <Button
          variant={showRecentNotes ? "secondary" : "ghost"}
          size="sm"
          onClick={onToggleRecentNotes}
          className="flex items-center gap-2"
        >
          <Clock className="h-4 w-4" />
          <span>Recent Notes</span>
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onNewNote}
          className="flex items-center gap-2"
        >
          <Plus className="h-4 w-4" />
          <span>New Note</span>
        </Button>
      </>
    }
  />
);

export default NotesNav; 